// extracted by mini-css-extract-plugin
export var alt = "ProfileAddress-module--alt--16644";
export var desktopOnly = "ProfileAddress-module--desktopOnly--443ef";
export var main = "ProfileAddress-module--main--ced5c";
export var mobileOnly = "ProfileAddress-module--mobileOnly--74154";
export var profileInfo = "ProfileAddress-module--profileInfo--38e85";
export var profileWrapper = "ProfileAddress-module--profileWrapper--08659";
export var textLeft = "ProfileAddress-module--textLeft--8bc89";
export var title = "ProfileAddress-module--title--59b70";
export var visuallyHidden = "ProfileAddress-module--visuallyHidden--71556";